import show from './yAxis.minorSplitLine.show'

export default {
  name: "minorSplitLine",
  nickname: "minorSplitLine",
  desc:
    '坐标轴在 <a target="__blank" href="https://echarts.apache.org/zh/option.html#grid">grid</a> 区域中的次分隔线。次分割线会对齐次刻度线 <a target="__blank" href="https://echarts.apache.org/zh/option.html#yAxis.minorTick">minorTick</a>',
  type: "object",
  props: {
    show,
  },
}
